import { useEffect, type RefObject } from 'react'

/** Close a popover on a click outside `ref` or on Escape, while `open`. */
export function useDismiss(ref: RefObject<HTMLElement | null>, open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return
    const onPointer = (event: MouseEvent) => {
      // A phone's filter sheet is portalled to <body>, so a tap in it is outside `ref` but not outside the popover.
      if ((event.target as Element | null)?.closest?.('[data-dismiss-keep]')) return
      if (ref.current && !ref.current.contains(event.target as Node)) onClose()
    }
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', onPointer)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onPointer)
      document.removeEventListener('keydown', onKey)
    }
  }, [ref, open, onClose])
}
